import { getCookie } from '@app/services'

import { checkReferrer } from './checkReferrer'
import { getBacktrackCookieName } from './constants'

export const getBacktrack = (): string | null => {
  const referrer = getCookie(getBacktrackCookieName())
  return checkReferrer(referrer) ? referrer : null
}
